import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-slate border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 md:py-16">
        <div className="flex flex-col md:flex-row justify-between gap-10">
          {/* Brand */}
          <div className="flex flex-col gap-4 max-w-xs">
            <img
              src="https://static.readdy.ai/image/eede9e94d3823189d88ba59164d5c11f/168c55980e2a35b55b08471421fd7088.png"
              alt="RESECOR"
              className="h-8 w-auto object-contain object-left"
            />
            <p className="font-body text-sm text-mid-grey leading-relaxed">
              Specialist advisory for technology companies pursuing contracts in UK national security and resilience markets.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-col sm:flex-row gap-10">
            <div className="flex flex-col gap-3">
              <span className="font-heading text-xs font-semibold tracking-widest uppercase text-mid-grey/60">Navigation</span>
              {[
                { label: "Home", path: "/" },
                { label: "Offers", path: "/offers" },
                { label: "About", path: "/about" },
                { label: "Contact", path: "/contact" },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="font-body text-sm text-mid-grey hover:text-white transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>
            <div className="flex flex-col gap-3">
              <span className="font-heading text-xs font-semibold tracking-widest uppercase text-mid-grey/60">Contact</span>
              <a
                href="mailto:enquiries@resecor.com"
                className="font-body text-sm text-mid-grey hover:text-copper transition-colors duration-200 cursor-pointer whitespace-nowrap"
                rel="nofollow"
              >
                enquiries@resecor.com
              </a>
              <p className="font-body text-xs text-mid-grey/60 max-w-[180px] leading-relaxed">
                We typically respond within one working day.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
          <p className="font-body text-xs text-mid-grey/50">
            &copy; {new Date().getFullYear()} Resecor. All rights reserved.
          </p>
          <p className="font-body text-xs text-mid-grey/40 hidden sm:block">
            UK National Security &amp; Resilience Advisory
          </p>
        </div>
      </div>
    </footer>
  );
}
